module.exports = __webpack_public_path__ + "670a20aa70dfa80a003dc2036334fc4a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/info-tooltip.png
// module id = 950
// module chunks = 0